
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Kode Wilayah', value: 'kode_wilayah'},
  { text: 'Branch Code', value: 'kode_cabang'},
  { text: 'Kode Cabang', value: 'branch_code'},
  { text: 'Nama Cabang', value: 'nama_cabang', width: '300'},
  { text: 'Kode Pos', value: 'kodepos'},
  { text: 'Provinsi', value: 'provinsi'},
  { text: 'Actions', value: 'action', width: '10'},
]);

export const search = {
  kode_cabang: '',
  kode_wilayah: '',
  kodepos: '',
};

